export default "__VITE_ASSET__CoMiSFDC__"